<template>
  <div class="announcement-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="(tableToolsPanel.indexOf('filter')>-1? '隐藏':'展开')+'筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="标题" prop="title">
                  <Input v-model="filterModel.title" placeholder="输入标题" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="类型" prop="types">
                  <Select v-model="filterModel.types" multiple>
                    <Option :value="0">公告</Option>
                    <Option :value="1">公示</Option>
                    <Option :value="2">政策法规</Option>
                    <Option :value="3">通知</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/announcements/add" icon="md-add">新增</Button>
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
</template>

<script>
export default {
  name: 'announcement-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '类型',
          key: 'type',
          width: 70,
          resizable: true,
          render: (h, params) => {
            return h('span', null, this.$common.announcementType[params.row.type.toString()])
          }
        },
        {
          title: '标题',
          key: 'title',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '发布人',
          key: 'announcerName',
          width: 160,
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '点阅次数',
          key: 'viewCount',
          width: 120,
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '置顶',
          key: 'isTop',
          width: 80,
          render: (h, params) => {
            return h('span', null, params.row.isTop ? '是' : '否')
          }
        },
        {
          title: '公开',
          key: 'isPublic',
          width: 80,
          render: (h, params) => {
            return h('span', null, params.row.isPublic ? '是' : '否')
          }
        },
        {
          title: '发布时间',
          key: 'createTime',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.createTime).format('YYYY-MM-DD'))
          }
        },
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-clipboard'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'announcement-detail', params: {id: params.row.tid}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'announcement-edit', params: {id: params.row.tid}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let id = params.row.tid
                      this.delete(id)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        title: null,
        content: null,
        type: null, // 0-公告|1-公示
        types: [0, 1, 2]
      },
      departments: [],
      curDepartmentId: null
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    if (this.$route.params.types) {
      this.filterModel.types = this.$route.params.types
    }
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Announcement.list(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async delete (id) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该公告么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Announcement.delete(id).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.tid === id}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
